import React from 'react';

import { cx } from '@emotion/css';
import { Category, Post, Tag } from '@lib/wordpress.d';

import { Card } from './Card';
import { NewNavigation } from './NewNavigation';
import { Tabs } from './Tabs';

type Props = {
  styles: any;
  posts: Post[];
  categories: Category[];
  tags: Tag[];
  page: number;
  totalPages: number;
  selectedCategory?: string;
  noPagiation?: Boolean;
  limit?: number;
};

export const CardList = (props: Props) => {
  const {
    styles,
    posts,
    categories,
    page,
    totalPages,
    selectedCategory,
    noPagiation,
    limit,
    tags,
  } = props;
  return (
    <div className={styles.blogs_cards_col}>
      <div className={styles.blogs_tabs}>
        <Tabs
          styles={styles}
          categories={categories}
          selectedCategory={selectedCategory}
        />
        <div className={styles.blogs_tab_data}>
          <div
            id="all"
            className={cx(styles.tab_content, styles.tab_content_active)}>
            <div className={styles.card_container}>
              {posts?.slice(0, limit || posts.length)?.map((post, index) => {
                if (post.sticky) return null;
                return (
                  <Card
                    key={index}
                    styles={styles}
                    post={post}
                    tags={tags}
                    categories={categories}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {!noPagiation ? (
        <NewNavigation
          page={page}
          totalPages={totalPages}
          selectedCategory={selectedCategory}
        />
      ) : null}
    </div>
  );
};
